export default __webpack_public_path__ + "static/char-36-anr-bcd0b73fd4e61c3bb6ff101a8e2263ec.webp";